var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MyChartPastHistoryCard_1;
import { Card, Text, TextFontSize } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import MyChartPastHistoryCardAPI from './my-chart-past-history-card-api';
import './my-chart-past-history-card.css';
import DateFormatterUtil from '../../util/date-utils/date-formatter-util';
let MyChartPastHistoryCard = MyChartPastHistoryCard_1 = class MyChartPastHistoryCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClickPastHistory = () => {
            const { onClick, disease, endDate, read, sequence, situation, startDate } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        disease,
                        endDate,
                        read,
                        sequence,
                        situation,
                        startDate
                    }
                }));
            }
        };
    }
    static { this.propTypes = { className: string, onClick: eventListener, uuid: string, width: number }; }
    static { this.defaultProps = { width: 12 }; }
    render() {
        const { uuid, width = MyChartPastHistoryCard_1.defaultProps.width, className, disease, endDate, situation, startDate, read } = this.props;
        const situationDescription = MessageService.translate(situation);
        const startDateFormat = startDate ? DateFormatterUtil.shortDate(startDate.toString()) : '-';
        const endDateFormat = endDate ? DateFormatterUtil.shortDate(startDate.toString()) : '-';
        const notViewedClass = read === 'N' ? 'not-viewed' : '';
        return (React.createElement(Card, { uuid: uuid, selectionType: SelectionType.SINGLE, width: width, className: `${className} ${notViewedClass}`, onClick: () => this.handleClickPastHistory() },
            React.createElement("div", { className: 'past-history' },
                React.createElement("div", { className: "detail-area-description" },
                    React.createElement("div", { className: "detail-area" },
                        React.createElement("div", { className: "info-content" },
                            React.createElement("span", { className: "label-info" },
                                React.createElement(Text, { value: `${MessageService.translate('patient.label.disease')}` })),
                            React.createElement("span", { className: "emphasis-info" },
                                React.createElement(Text, { bold: true, size: TextFontSize.SMALL, value: disease, className: "subtitle" })))),
                    React.createElement("div", { className: "detail-area" },
                        React.createElement("div", { className: "info-content" },
                            React.createElement("span", { className: "label-info" },
                                React.createElement(Text, { value: `${MessageService.translate('patient.label.status')}` })),
                            React.createElement("span", { className: "emphasis-info" },
                                React.createElement(Text, { bold: true, size: TextFontSize.SMALL, value: situationDescription, className: "subtitle" }))))),
                React.createElement("div", { className: "detail-area-date" },
                    React.createElement("div", { className: "detail-area" },
                        React.createElement("div", { className: "info-content" },
                            React.createElement("span", { className: "label-info" },
                                React.createElement(Text, { value: `${MessageService.translate('patient.label.start-date')}` })),
                            React.createElement("span", { className: "emphasis-info" },
                                React.createElement(Text, { bold: true, size: TextFontSize.SMALL, value: startDateFormat, className: "subtitle" })))),
                    React.createElement("div", { className: "detail-area" },
                        React.createElement("div", { className: "info-content" },
                            React.createElement("span", { className: "label-info" },
                                React.createElement(Text, { value: `${MessageService.translate('patient.label.end-date')}` })),
                            React.createElement("span", { className: "emphasis-info" },
                                React.createElement(Text, { bold: true, size: TextFontSize.SMALL, value: endDateFormat, className: "subtitle" }))))))));
    }
};
MyChartPastHistoryCard = MyChartPastHistoryCard_1 = __decorate([
    AwesomeComponent({ api: MyChartPastHistoryCardAPI, type: ComponentType.DATA_DISPLAY })
], MyChartPastHistoryCard);
export default MyChartPastHistoryCard;
//# sourceMappingURL=my-chart-past-history-card.js.map